import axios from 'axios';

export default {

    //Permet de récuperer le nombre de points boutique et le lien de l'utilisateur
    get(userId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/shop/' + userId + '/data');
    }
}
